/* Wishlist Engine — the page (Sep 10 2026)
   Contract: docs/plans/2026-09-10-wishlist-engine.md

   Reads the saved list from window.WowWishlist (assets/wishlist-sync.js) and the LIVE price and
   stock for each piece from Shopify itself, through templates/search.wishlist-data.liquid.
   Nothing on this page is invented: a price comes from Shopify, a stock word comes from the
   variant's own availability, and a piece we cannot find is said to be one we cannot serve
   rather than quietly dropped.

   Every promise about sourcing is shown with WHO answers and BY WHEN, per the contract's
   binding rule. If those are missing from the config the form is not shown at all. */
(function () {
  'use strict';
  var roots = [].slice.call(document.querySelectorAll('[data-wq-page]'));
  if (!roots.length) return;

  var CFG = window.WOW_WISHLIST_CFG || {};
  var OWNER = CFG.sourcing_owner || '';
  var SLA = CFG.sourcing_sla || '';
  var GIVING = '5% of each sale goes to a cause you choose.';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SEARCH = (window.routes && window.routes.search_url) || (ROOT + 'search');
  var CART_ADD = ROOT + 'cart/add.js';
  var PLACEHOLDER = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><rect width="4" height="5" fill="#EFEAE2"/></svg>');
  var SIZE_SEEN_MS = 30 * 864e5; /* how long we remember that a saved size was gone */

  function Q() { return window.WowWishlist; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function $(s, r) { return (r || document).querySelector(s); }
  function toast(msg, action) {
    var t = $('.wq-toast'); if (!t) { t = el('div', 'wq-toast'); document.body.appendChild(t); }
    t.textContent = ''; t.appendChild(document.createTextNode(msg));
    if (action) { var b = el('button', 'wq-link', action.label); b.style.color = '#fff'; b.style.marginLeft = '10px'; b.style.pointerEvents = 'auto'; b.addEventListener('click', function () { t.classList.remove('show'); action.fn(); }); t.appendChild(b); t.style.pointerEvents = 'auto'; }
    else { t.style.pointerEvents = 'none'; }
    t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, action ? 6000 : 2800);
  }

  /* ---------- live product data, straight from Shopify ---------- */
  var cache = {};
  function fetchChunk(ids) {
    var q = ids.map(function (i) { return 'id:' + i; }).join(' OR ');
    var url = SEARCH + '?view=wishlist-data&type=product&options[unavailable_products]=last&q=' + encodeURIComponent(q);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { var m = t.match(/\{[\s\S]*\}/); if (m) { try { j = JSON.parse(m[0]); } catch (e2) {} } }
        return (j && Array.isArray(j.products)) ? j.products : [];
      })
      .catch(function () { return []; });
  }
  function loadProducts(ids) {
    var todo = ids.filter(function (i) { return !cache[i]; });
    if (!todo.length) return Promise.resolve(cache);
    var chunks = [];
    for (var i = 0; i < todo.length; i += 20) chunks.push(todo.slice(i, i + 20));
    return Promise.all(chunks.map(fetchChunk)).then(function (lists) {
      lists.forEach(function (ps) { ps.forEach(function (p) { if (p && p.id != null) cache[String(p.id)] = p; }); });
      return cache;
    });
  }

  /* ---------- honest state + per-piece delivery ---------- */
  function variantOf(p, vid) {
    if (!p || !vid) return null;
    for (var i = 0; i < (p.variants || []).length; i++) if (String(p.variants[i].id) === String(vid)) return p.variants[i];
    return null;
  }
  function firstAvailable(p) {
    var vs = (p && p.variants) || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0] || null;
  }
  function madeToOrder(p) { return !!(p && (p.gelato || p.order_policy === 'madetoorder')); }
  function preorder(p) { return !!(p && p.order_policy === 'backorder' && !p.available); }

  function stockState(id, p) {
    if (!p) return { key: 'gone', label: 'Not in the shop right now — we can look for it', sourceable: true };
    var meta = Q().meta(id), v = variantOf(p, meta.variant_id);
    if (madeToOrder(p)) return { key: 'in', label: 'Made for you when you order', sourceable: false };
    if (preorder(p)) return { key: 'wait', label: 'Pre-order', sourceable: false };
    if (!p.available) return { key: 'gone', label: 'Sold out — we can look for it', sourceable: true };
    if (v) {
      var gone = meta.size_gone_at && (Date.now() - meta.size_gone_at) < SIZE_SEEN_MS;
      if (v.available) {
        if (gone) return { key: 'back', label: 'Your size is back: ' + v.title, sourceable: false, clearGone: true };
        return { key: 'in', label: 'In stock in ' + v.title, sourceable: false };
      }
      return { key: 'wait', label: v.title + ' is sold out — other sizes are in stock', sourceable: true, markGone: true };
    }
    return { key: 'in', label: 'In stock', sourceable: false };
  }
  function delivery(p) {
    if (!p) return '';
    if (madeToOrder(p)) return 'Made for you when you order — about 2–3 weeks.';
    if (preorder(p)) return 'Pre-order — ships in about 2–3 weeks.';
    if (p.available) return 'In stock. The delivery time for this piece is confirmed at checkout, before you pay.';
    return '';
  }

  /* ---------- one saved piece ---------- */
  function card(ctx, id) {
    var p = cache[id] || null, meta = Q().meta(id);
    var st = stockState(id, p);
    if (st.markGone && !meta.size_gone_at) Q().setMetaLocal(id, { size_gone_at: Date.now() });
    if (st.clearGone) Q().setMetaLocal(id, { size_gone_at: 0 });
    /* the server checked this variant against Shopify too; when it says sold out, it wins */
    var srv = ctx.serverState[id];
    if (srv && srv.checked === 'live' && srv.in_stock === false && st.key !== 'gone') {
      st = { key: 'gone', label: 'Sold out — we can look for it', sourceable: true };
    }

    var c = el('div', 'wq-card');
    var top = el('div', 'wq-card__top');
    var href = p ? p.url : null;

    var th = href ? el('a', 'wq-card__thumb') : el('div', 'wq-card__thumb');
    if (href) { th.href = href; th.setAttribute('aria-hidden', 'true'); th.tabIndex = -1; }
    var im = el('img'); im.src = (p && p.image) || PLACEHOLDER; im.alt = ''; im.loading = 'lazy';
    im.addEventListener('error', function () { im.src = PLACEHOLDER; });
    th.appendChild(im); top.appendChild(th);

    var body = el('div', 'wq-card__body');
    var h = el('h3', 'wq-card__title');
    if (p) { var a = el('a', null, String(p.title || '').replace(/ \| WowStore\.live/i, '')); a.href = p.url; h.appendChild(a); }
    else { h.textContent = 'A piece you saved'; }
    body.appendChild(h);

    if (p && p.vendor) body.appendChild(el('p', 'wq-card__vendor', p.vendor));

    if (p) {
      var pr = el('p', 'wq-card__price');
      pr.appendChild(document.createTextNode(p.price_varies ? ('from ' + p.price_min_money) : p.price_money));
      if (p.compare_at_money) { var s = el('s', null, p.compare_at_money); pr.appendChild(s); }
      body.appendChild(pr);
    } else {
      body.appendChild(el('p', 'wq-card__vendor', 'We could not find this piece in the shop today. It is still on your list.'));
    }

    var chip = el('span', 'wq-state wq-state--' + st.key, st.label);
    body.appendChild(chip);

    /* a price move we can prove: what the server recorded when it was saved vs what it costs now */
    if (srv && typeof srv.price_delta === 'number' && srv.price_delta < 0 && p) {
      var pd = el('p', 'wq-delivery');
      pd.style.color = '#4F7F8F';
      pd.textContent = 'Cheaper than when you saved it, by ' + Math.abs(srv.price_delta).toFixed(2) + ' ' + (srv.currency || 'EUR') + '.';
      body.appendChild(pd);
    }

    var dl = delivery(p);
    if (dl) body.appendChild(el('p', 'wq-delivery', dl));

    top.appendChild(body); c.appendChild(top);

    /* size, when there is a choice to make */
    var sizeSel = null;
    if (p && (p.variants || []).length > 1) {
      var fld = el('div', 'wq-field'); fld.style.padding = '0 14px 4px';
      var lab = el('label', null, (p.option_names && p.option_names.length === 1 ? p.option_names[0] : 'Size / option'));
      lab.htmlFor = 'wq-v-' + ctx.uid + '-' + id; fld.appendChild(lab);
      sizeSel = el('select'); sizeSel.id = 'wq-v-' + ctx.uid + '-' + id;
      p.variants.forEach(function (v) {
        var o = el('option', null, v.title + (v.available ? '' : ' — sold out'));
        o.value = String(v.id); if (!v.available) o.disabled = false; /* selectable so the shopper can ask us to source it */
        if (String(meta.variant_id || '') === String(v.id)) o.selected = true;
        sizeSel.appendChild(o);
      });
      if (!meta.variant_id) { var fa = firstAvailable(p); if (fa) sizeSel.value = String(fa.id); }
      sizeSel.addEventListener('change', function () {
        var v = variantOf(p, sizeSel.value);
        Q().setVariant(id, sizeSel.value, { handle: p.handle, title: String(p.title || '').replace(/ \| WowStore\.live/i, ''), price: v ? (v.price / 100) : (p.price / 100) })
          .then(function () { ctx.rerender(); });
        ctx.rerender();
      });
      fld.appendChild(sizeSel); c.appendChild(fld);
    }

    /* the plan: a note, a date, a budget — Lucy can help rather than push */
    if (ctx.mode !== 'account') {
      var plan = el('div', 'wq-card__plan');
      var row = el('div', 'wq-plan__row');
      var f1 = el('div', 'wq-field'); f1.style.flexBasis = '100%';
      var l1 = el('label', null, 'Why you saved it'); l1.htmlFor = 'wq-n-' + ctx.uid + '-' + id; f1.appendChild(l1);
      var ta = el('textarea'); ta.id = l1.htmlFor; ta.value = meta.note || ''; ta.maxLength = 500;
      ta.placeholder = 'For the wedding in June. Only if it comes in navy.';
      f1.appendChild(ta); row.appendChild(f1);

      var f2 = el('div', 'wq-field');
      var l2 = el('label', null, 'Wanted by'); l2.htmlFor = 'wq-d-' + ctx.uid + '-' + id; f2.appendChild(l2);
      var di = el('input'); di.type = 'date'; di.id = l2.htmlFor; di.value = meta.target_date || ''; f2.appendChild(di); row.appendChild(f2);

      var f3 = el('div', 'wq-field');
      var l3 = el('label', null, 'Budget (optional)'); l3.htmlFor = 'wq-b-' + ctx.uid + '-' + id; f3.appendChild(l3);
      var bi = el('input'); bi.type = 'number'; bi.min = '0'; bi.step = '1'; bi.inputMode = 'decimal'; bi.id = l3.htmlFor;
      bi.value = (meta.budget === 0 || meta.budget) ? meta.budget : ''; bi.placeholder = '—'; f3.appendChild(bi); row.appendChild(f3);

      plan.appendChild(row);
      var note = el('p', 'wq-note-state', '');
      plan.appendChild(note);

      var t = null;
      function save() {
        clearTimeout(t);
        t = setTimeout(function () {
          note.textContent = 'Saving…';
          Q().saveMeta(id, { note: ta.value.slice(0, 500), target_date: di.value || '', budget: bi.value === '' ? '' : bi.value })
            .then(function (r) {
              note.textContent = (r && r.ok) ? 'Saved to your account.' : 'Saved on this device. We will put it on your account when the service answers.';
              setTimeout(function () { note.textContent = ''; }, 4000);
            });
        }, 700);
      }
      ta.addEventListener('input', save); di.addEventListener('change', save); bi.addEventListener('input', save);
      c.appendChild(plan);
    }

    /* actions */
    var acts = el('div', 'wq-card__acts');
    if (p && p.available) {
      var add = el('button', 'wq-btn wq-btn--small', 'Move to cart'); add.type = 'button';
      add.addEventListener('click', function () {
        var vid = sizeSel ? sizeSel.value : ((firstAvailable(p) || {}).id);
        var v = variantOf(p, vid);
        if (!v || !v.available) { toast('That size is sold out. Ask us to look for it below.'); return; }
        add.disabled = true; add.textContent = 'Adding…';
        fetch(CART_ADD, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () {
            try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
            try { if (window.LucyCart && window.LucyCart.refresh) window.LucyCart.refresh(); } catch (e) {}
            var before = Q().local();
            Q().write(before.filter(function (x) { return String(x) !== String(id); }));
            toast('In your cart, and off your list.', { label: 'Undo', fn: function () { Q().write(Q().local().concat([String(id)])); } });
            ctx.rerender();
          })
          .catch(function () { add.disabled = false; add.textContent = 'Move to cart'; toast('That did not go through. Try once more.'); });
      });
      acts.appendChild(add);
    } else if (p) {
      var view = el('a', 'wq-btn wq-btn--ghost wq-btn--small', 'See the piece'); view.href = p.url; acts.appendChild(view);
    }

    if (st.sourceable && OWNER && SLA) {
      var ask = el('button', 'wq-btn wq-btn--ghost wq-btn--small', 'Ask us to find it'); ask.type = 'button';
      ask.addEventListener('click', function () {
        ctx.prefillSourcing({
          product_id: id,
          title: p ? String(p.title || '').replace(/ \| WowStore\.live/i, '') : '',
          url: p ? (location.origin + p.url) : '',
          size: sizeSel ? (variantOf(p, sizeSel.value) || {}).title : '',
          note: meta.note || ''
        });
      });
      acts.appendChild(ask);
    }

    var rm = el('button', 'wq-link', 'Remove'); rm.type = 'button';
    rm.addEventListener('click', function () {
      var before = Q().local();
      Q().write(before.filter(function (x) { return String(x) !== String(id); }));
      toast('Removed.', { label: 'Undo', fn: function () { Q().write(before); ctx.rerender(); } });
      ctx.rerender();
    });
    acts.appendChild(rm);
    c.appendChild(acts);
    return c;
  }

  /* ---------- sourcing: never shown without the named human and the time ---------- */
  function sourcingBlock(ctx) {
    if (!OWNER || !SLA) return null;
    var box = el('div', 'wq-src'); box.id = 'wq-sourcing';
    box.appendChild(el('h3', null, 'Ask us to find something'));
    box.appendChild(el('p', null, 'A piece we do not carry, a size that went, something you saw elsewhere — tell us what it is. We look, and we tell you honestly whether we can get it. We cannot get everything, and we will say so.'));

    var who = el('div', 'wq-who');
    var b = el('b', null, OWNER + ' answers you personally');
    who.appendChild(b);
    who.appendChild(el('span', null, SLA));
    box.appendChild(who);

    var no = el('p', null, 'If the answer is no it reads: “We couldn’t get this one at a price we’d stand behind. Here are the two closest pieces we can.”');
    no.style.fontSize = '13.5px'; no.style.margin = '0 0 16px';
    box.appendChild(no);

    var form = el('form', 'wq-src__form'); form.noValidate = true;
    function field(id, label, type, ph, wide, required) {
      var f = el('div', 'wq-field' + (wide ? ' wq-field--wide' : ''));
      var l = el('label', null, label + (required ? '' : ' (optional)')); l.htmlFor = 'wq-src-' + id; f.appendChild(l);
      var i = type === 'textarea' ? el('textarea') : el('input');
      if (type !== 'textarea') i.type = type;
      i.id = l.htmlFor; i.name = id; if (ph) i.placeholder = ph;
      i.maxLength = type === 'textarea' ? 1200 : 200;
      f.appendChild(i); form.appendChild(f); return i;
    }
    var fWhat = field('what', 'What are you looking for', 'textarea', 'A long linen coat in stone, size M. Anything close in feel.', true, true);
    var fLink = field('link', 'A link or a picture you saw', 'url', 'https://…', true, false);
    var fSize = field('size', 'Size', 'text', '', false, false);
    var fBudget = field('budget', 'Budget', 'number', '€', false, false);
    var fBy = field('by', 'Wanted by', 'date', '', false, false);
    var fEmail = field('email', 'Where we reply', 'email', 'you@example.com', false, true);
    /* signed in: the address we already hold, so nobody retypes it (theme.liquid emits it) */
    try { if (CFG.customer && typeof window.__WOWS_EMAIL === 'string' && window.__WOWS_EMAIL) fEmail.value = window.__WOWS_EMAIL; } catch (e) {}

    var foot = el('div', 'wq-src__foot');
    var send = el('button', 'wq-btn wq-btn--purple', 'Send it to ' + OWNER); send.type = 'submit';
    var msg = el('span', 'wq-src__msg', '');
    foot.appendChild(send); foot.appendChild(msg); form.appendChild(foot);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.className = 'wq-src__msg';
      if (!fWhat.value.trim()) { msg.className = 'wq-src__msg wq-src__msg--err'; msg.textContent = 'Tell us what to look for first.'; fWhat.focus(); return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(fEmail.value.trim())) { msg.className = 'wq-src__msg wq-src__msg--err'; msg.textContent = 'We need an address to reply to.'; fEmail.focus(); return; }
      send.disabled = true; msg.textContent = 'Sending…';
      var body = {
        request_text: fWhat.value.trim().slice(0, 1200),
        link: fLink.value.trim().slice(0, 500),
        size: fSize.value.trim().slice(0, 60),
        budget: fBudget.value === '' ? null : fBudget.value,
        target_price: fBudget.value === '' ? null : fBudget.value,
        wanted_by: fBy.value || '',
        target_date: fBy.value || '',
        email: fEmail.value.trim().slice(0, 160),
        product_id: form.dataset.productId || '',
        page: location.pathname
      };
      Q().sourcing(body).then(function (r) {
        send.disabled = false;
        if (r && r.ok) {
          msg.className = 'wq-src__msg wq-src__msg--ok';
          var pr = r.data && r.data.promise, by = (r.data && r.data.request && r.data.request.promised_by) || '';
          var when = '';
          try { if (by) when = ' by ' + new Date(by).toLocaleString('en-GB', { weekday: 'long', hour: '2-digit', minute: '2-digit' }); } catch (e) {}
          msg.textContent = 'With ' + ((pr && pr.answered_by) || OWNER) + '. He answers you' + (when || ' ' + SLA) + '.';
          form.reset(); delete form.dataset.productId;
        } else {
          msg.className = 'wq-src__msg wq-src__msg--err';
          msg.textContent = 'That did not reach us. Mail info@wowstore.live and ' + OWNER + ' picks it up ' + SLA + '.';
        }
      });
    });
    box.appendChild(form);

    ctx.prefillSourcing = function (d) {
      form.dataset.productId = d.product_id || '';
      var lines = [];
      if (d.title) lines.push(d.title);
      if (d.size) lines.push('Size: ' + d.size);
      if (d.note) lines.push(d.note);
      if (lines.length) fWhat.value = lines.join('\n');
      if (d.url) fLink.value = d.url;
      if (d.size) fSize.value = d.size;
      try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); }
      setTimeout(function () { fWhat.focus(); }, 350);
    };
    return box;
  }

  /* ---------- render ---------- */
  function build(root) {
    var ctx = {
      uid: Math.random().toString(36).slice(2, 7),
      mode: root.dataset.wqMode || 'page',
      limit: parseInt(root.dataset.wqLimit, 10) || 0,
      serverState: {},
      prefillSourcing: function () {}
    };
    var listBox = $('[data-wq-list]', root);
    var countBox = $('[data-wq-count]', root);
    var noteBox = $('[data-wq-notice]', root);
    var srcHost = $('[data-wq-sourcing]', root);
    var src = ctx.mode === 'account' ? null : sourcingBlock(ctx);
    if (src && srcHost) srcHost.appendChild(src);

    function skeleton(n) {
      listBox.textContent = '';
      var g = el('div', 'wq__grid');
      for (var i = 0; i < n; i++) g.appendChild(el('div', 'wq__skel'));
      listBox.appendChild(g);
    }

    function emptyState() {
      var s = el('div', 'wq__state');
      s.appendChild(el('h3', null, 'Nothing saved yet'));
      s.appendChild(el('p', null, 'Tap the heart on any piece and it lands here — with its price, whether it is in stock, and room for a note about why you saved it. Saved pieces follow you now, not your browser cache.'));
      var ctas = el('div', 'wq__ctas');
      var a = el('a', 'wq-btn', 'Browse the shop'); a.href = '/collections/all'; ctas.appendChild(a);
      var b2 = el('a', 'wq-btn wq-btn--ghost', 'Ask us to find something'); b2.href = '#wq-sourcing'; if (src) ctas.appendChild(b2);
      s.appendChild(ctas);
      return s;
    }

    function notice() {
      if (!noteBox) return;
      noteBox.textContent = '';
      var q = Q();
      if (q.online === false) {
        var n = el('div', 'wq-offline');
        n.textContent = 'Your list is showing from this browser — we could not reach the wishlist service just now. Nothing is lost: what you change here is kept and goes across as soon as it answers.';
        noteBox.appendChild(n);
      }
    }

    function render() {
      var ids = Q().local();
      if (ctx.limit && ids.length > ctx.limit) ids = ids.slice(0, ctx.limit);
      if (countBox) countBox.textContent = ids.length ? (ids.length + (ids.length === 1 ? ' piece saved' : ' pieces saved')) : '';
      notice();
      if (!ids.length) { listBox.textContent = ''; listBox.appendChild(emptyState()); return; }
      skeleton(Math.min(ids.length, 6));
      loadProducts(ids).then(function () {
        listBox.textContent = '';
        var g = el('div', 'wq__grid');
        ids.forEach(function (id) { g.appendChild(card(ctx, String(id))); });
        listBox.appendChild(g);
      });
    }
    ctx.rerender = render;

    /* what the server itself checked against Shopify: real stock, and the move against the
       price recorded when the piece was saved. Nothing here is estimated. */
    function pullStatus(ids) {
      if (!ids.length || Q().online === false) return Promise.resolve();
      return Q().req(Q().EP.status + '?' + Q().custQ())
        .then(function (r) {
          if (!r.ok || !r.data) return;
          var arr = Array.isArray(r.data) ? r.data : (r.data.items || r.data.products || []);
          if (!Array.isArray(arr)) return;
          arr.forEach(function (x) {
            if (!x || x.product_id == null) return;
            ctx.serverState[String(x.product_id)] = {
              in_stock: x.in_stock, price_now: x.price_now, price_delta: x.price_delta,
              product_status: x.product_status, checked: x.checked, currency: x.currency
            };
          });
          render();
        });
    }

    /* give the server a title and a price for anything the heart could only save as an id */
    function enrichAll(ids) {
      if (Q().online === false) return;
      ids.forEach(function (id) {
        var p = cache[id]; if (!p) return;
        Q().enrich(id, { handle: p.handle, title: String(p.title || '').replace(/ \| WowStore\.live/i, ''), price: p.price / 100 });
      });
    }

    function afterSync() {
      var ids = Q().local();
      render();
      loadProducts(ids).then(function () { enrichAll(ids); pullStatus(ids); });
    }
    render();
    Q().onChange(function () { render(); });
    if (Q().ready && Q().ready.then) Q().ready.then(afterSync); else setTimeout(afterSync, 1500);
  }

  function boot() {
    if (!Q()) { setTimeout(boot, 120); return; }
    roots.forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
